import { useMutation } from "@apollo/client";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonPage,
  IonSpinner,
  IonTextarea,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { SUPPORT } from "graphql/mutations";
import { chevronBackOutline, paperPlaneOutline } from "ionicons/icons";
import { useState } from "react";
import { useHistory } from "react-router-dom";

const Support = () => {
  const [message, setMessage] = useState({});
  const [showLoading, setShowLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const history = useHistory();

  const [insertSupport] = useMutation(SUPPORT);

  const submitMessage = async () => {
    if (message.subject === "" || message.content === "")
      return alert("All fields are required.");

    setShowLoading(true);

    const payload = {
      variables: {
        message: JSON.stringify(message),
      },
    };
    const res = await insertSupport(payload);
    if (res?.data?.insert_support_tickets_one) {
      setShowLoading(false);
      alert("Support request sent. We will get back to you within 48 hours.");
      setMessage({});
    } else {
      setShowLoading(false);
      alert("An error occurred.");
    }
  };

  const onChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setMessage((prevState) => {
      return { ...prevState, [name]: value };
    });
    setDisabled(!message.subject || !message.content);
  };

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar className="background-color">
          <IonButtons slot="start">
            <IonButton onClick={() => history.goBack()}>
              <IonIcon icon={chevronBackOutline} color="dark" size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>Support Center</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={() => submitMessage()} disabled={disabled}>
              {showLoading ? (
                <IonSpinner name="crescent" />
              ) : (
                <IonIcon icon={paperPlaneOutline} color="dark" />
              )}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">Support Center</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonList>
          <IonItem>
            <IonLabel position="stacked">Subject</IonLabel>
            <IonInput
              type="text"
              name="subject"
              placeholder="subject..."
              value={message.subject}
              onIonChange={(e) => onChange(e)}
              required
            ></IonInput>
          </IonItem>
          <IonItem>
            <IonLabel position="stacked">Issue</IonLabel>
            <IonTextarea
              name="content"
              placeholder="What can we help with?"
              value={message.content}
              rows={15}
              onIonChange={(e) => onChange(e)}
              required
            ></IonTextarea>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export default Support;
